/**
 * Los personajes del Bloque 3.
 *
 * La metodología v3.1 enumera 14. El catálogo tiene 10, después de dos rondas
 * de depuración del comando con la oleada W1 todavía en piloto. El número vive
 * aquí y en ningún otro sitio —ni el instrumento, ni la PWA, ni el panel lo
 * fijan— para que no vuelva a quedar desincronizado.
 *
 * REGLA DE NOMBRES (§Bloque 3): todos se presentan con el nombre con que son
 * conocidos públicamente y con la misma estructura (nombre + apellido). No se
 * usa nombre completo para unos y abreviado para otros, porque alarga y
 * destaca ese reactivo.
 *
 * La tarjeta muestra ÚNICAMENTE `cardName`: sin partido, sin foto y sin cargo.
 * `referenceParty` es información interna para el análisis de asociación
 * partidista (I4, indicador §10.1.6) y NUNCA se envía a la PWA.
 */
export const PERSONAJES = [
    { id: 'sarahi-osuna', catalogOrder: 1, cardName: 'Sarahí Osuna', referenceParty: 'MORENA' },
    { id: 'maythe-mendez', catalogOrder: 2, cardName: 'Maythé Méndez', referenceParty: 'MORENA' },
    { id: 'maria-quijada', catalogOrder: 3, cardName: 'María Quijada', referenceParty: 'MORENA' },
    { id: 'isaac-contreras', catalogOrder: 4, cardName: 'Isaac Contreras', referenceParty: 'PVEM' },
    {
        id: 'dario-benitez',
        catalogOrder: 5,
        cardName: 'Darío Benítez',
        referenceParty: 'PES_BC',
        secondaryParties: ['PAZ'],
        notes: 'Personaje principal del experimento de etiqueta partidista (X1). Vinculado a la firma que levanta el estudio; ver nota de conflicto de interés en §11.',
    },
    { id: 'karolina-fraijo', catalogOrder: 6, cardName: 'Karolina Fraijo', referenceParty: 'PES_BC' },
    { id: 'pedro-torres', catalogOrder: 7, cardName: 'Pedro Torres', referenceParty: 'PES_BC' },
    { id: 'tere-ruiz', catalogOrder: 8, cardName: 'Tere Ruiz', referenceParty: 'PES_BC' },
    {
        id: 'beto-valle',
        catalogOrder: 9,
        cardName: 'Beto Valle',
        referenceParty: 'PRI',
        notes: 'Personaje de control del experimento X1: se contrasta la etiqueta PRI solo contra la alianza PAN-PRI-PES BC.',
    },
    {
        id: 'roman-cota',
        catalogOrder: 10,
        cardName: 'Román Cota Muñoz',
        referenceParty: 'MORENA',
        isControl: true,
        evaluatedInBlock4: true,
        notes: 'Alcalde actual, personaje de control. El Bloque 4 (G1) se aplica DESPUÉS de la notoriedad espontánea para no contaminar el top-of-mind (corrección #5 de la v2).',
    },
];
export const PERSONAJE_BY_ID = Object.fromEntries(PERSONAJES.map((p) => [p.id, p]));
export const PERSONAJE_IDS = PERSONAJES.map((p) => p.id);
export function toPersonajeCard(p) {
    return { id: p.id, cardName: p.cardName };
}
/* -------------------------------------------------------------------------- */
/*                    Funcionarios evaluados en el Bloque 4                   */
/* -------------------------------------------------------------------------- */
export const BLOCK4_OFFICIALS = [
    { id: 'roman-cota', questionCode: 'G1', name: 'Román Cota Muñoz', office: 'presidente municipal' },
    {
        id: 'marina-del-pilar',
        questionCode: 'G2',
        name: 'Marina del Pilar Ávila',
        office: 'gobernadora',
    },
    {
        id: 'claudia-sheinbaum',
        questionCode: 'G3',
        name: 'Claudia Sheinbaum',
        office: 'presidenta de la República',
    },
];
//# sourceMappingURL=personajes.js.map